var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTax = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Electronic-Billing-Tax-Document--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Electronic Billing Tax Document Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M18 16.75H6.5a0.75 0.75 0 0 0 0 1.5H18a0.75 0.75 0 0 0 0 -1.5Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.75 9.25V14a0.75 0.75 0 0 0 1.5 0V9.25h0.5a0.75 0.75 0 0 0 0 -1.5h-2.5a0.75 0.75 0 0 0 0 1.5Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5 14.75a0.76 0.76 0 0 0 0.75 -0.75v-1h1v1a0.75 0.75 0 0 0 1.5 0V9.75a2 2 0 0 0 -4 0V14a0.76 0.76 0 0 0 0.75 0.75Zm1.25 -5.5a0.5 0.5 0 0 1 0.5 0.5v1.75h-1V9.75a0.5 0.5 0 0 1 0.5 -0.5Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.24 14.7a0.6 0.6 0 0 0 0.26 0.05 0.74 0.74 0 0 0 0.7 -0.49l0.3 -0.81 0.29 0.81a0.77 0.77 0 0 0 0.71 0.49 0.63 0.63 0 0 0 0.26 -0.05 0.74 0.74 0 0 0 0.44 -1l-0.9 -2.49 0.9 -2.49a0.75 0.75 0 0 0 -0.44 -1 0.76 0.76 0 0 0 -1 0.45l-0.29 0.81 -0.3 -0.81a0.75 0.75 0 0 0 -1 -0.45 0.76 0.76 0 0 0 -0.45 1l0.91 2.49 -0.91 2.49a0.75 0.75 0 0 0 0.52 1Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.71 5.71 16.29 0.29a1 1 0 0 0 -0.7 -0.29H4a2 2 0 0 0 -2 2v20a2 2 0 0 0 2 2h16a2 2 0 0 0 2 -2V6.41a1 1 0 0 0 -0.29 -0.7ZM20 21.5a0.5 0.5 0 0 1 -0.5 0.5h-15a0.5 0.5 0 0 1 -0.5 -0.5v-19a0.5 0.5 0 0 1 0.5 -0.5H15a0.49 0.49 0 0 1 0.36 0.15l4.53 4.53A0.49 0.49 0 0 1 20 7Z",
    fill: "currentColor",
    strokeWidth: 1
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTax);
export default ForwardRef;